import type { TemplateDataobject, Graph } from "@lr-notitia/notitia-operator/schemas";
import { Ref, computed } from "vue";
import { useSymbolsStore } from "../symbols";

let symbolsStore: ReturnType<typeof useSymbolsStore>;
function init() {
	symbolsStore = useSymbolsStore();
}

export const templateDataobjects = (graph: Ref<Graph>) =>
	computed<TemplateDataobject[]>(() => {
		if (!symbolsStore) init();
		return (
			Object.values(graph.value.nodes).filter(
				(node) => node.type === "dataobject" && node.layer === "template"
			) as TemplateDataobject[]
		).sort((a, b) =>
			symbolsStore
				.term({ id: a.refersTo, terminology: a.terminology })
				.toLocaleLowerCase()
				.localeCompare(symbolsStore.term({ id: b.refersTo, terminology: b.terminology }).toLocaleLowerCase())
		);
	});
export function templateDataobject(domainId: Ref<string>, graph: Ref<Graph>) {
	return {
		byId: (id: string) => byId(id, graph),
	};
}

function byId(id: string, graph: Ref<Graph>): TemplateDataobject | undefined {
	let hit = graph.value.nodes[id];
	return hit && hit.type === "dataobject" && hit.layer === "template" ? (hit as TemplateDataobject) : undefined;
}
